import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Which marketplaces does Sellcraft support?",
    a: "eBay, Facebook Marketplace and Gumtree. eBay listings can be published directly from the app with calculated shipping; Facebook and Gumtree listings are generated ready to post in one tap.",
  },
  {
    q: "How accurate are the price estimates?",
    a: "Estimates are based on real sold comparables for similar items. They give you a realistic range to list at — you can always adjust the final price before posting.",
  },
  {
    q: "What's included in the free plan?",
    a: "The free plan gives you 1 scan per day with full access to every feature — AI identification, price estimates and listing creation for all three marketplaces. No card required.",
  },
  {
    q: "How does the 3-day free trial work?",
    a: "Eligible new subscribers can try Starter or Pro free for 3 days. The trial is managed entirely by Google Play, and you'll be notified before it converts to a paid subscription.",
  },
  {
    q: "How do I cancel my subscription?",
    a: "Open the Google Play Store, go to Payments & subscriptions → Subscriptions, select Sellcraft and tap Cancel. You keep access until the end of the current billing period.",
  },
  {
    q: "What happens to my photos and data?",
    a: "Your photos are processed to identify the item and build your listing. We don't sell or share your photos or personal data with third parties. See our Privacy Policy for full details.",
  },
  {
    q: "Which devices are supported?",
    a: "Sellcraft is available on Android through Google Play. Any modern Android phone with a camera will work.",
  },
];

const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="section-anchor py-24">
    <div className="mx-auto max-w-3xl px-4 sm:px-6">
      <p className="font-display text-sm font-semibold uppercase tracking-widest text-brand-light">FAQ</p>
      <h2 className="mt-3 font-display text-3xl font-bold uppercase tracking-wide text-onsurface sm:text-4xl">
        Questions, answered
      </h2>

      <Accordion type="single" collapsible className="mt-10">
        {FAQS.map((item, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-divider">
            <AccordionTrigger
              data-testid={`faq-question-${i}`}
              className="text-left font-display text-base font-semibold uppercase tracking-wide text-onsurface hover:text-brand-light hover:no-underline"
            >
              {item.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm leading-relaxed text-onsurface2">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
